export function screenReaderSlideTitle(title: string): string {
  return title.replace(".", " point ");
}
